// extracted by mini-css-extract-plugin
export default {"blockquote":"blockquote--bmBC6VKhZZLdc8pjyE78"};